import React from 'react';
import './SkeletonBadgesLeaderboardRow.css';

export default function SkeletonBadgesLeaderboardRow({
  count = 10,
}) {
  const podiumCount = Math.min(count, 3);
  const remainingCount = Math.max(count - podiumCount, 0);

  const podiumPositions = [
    'second',
    'first',
    'third',
  ];

  return (
    <div
      className="blb-skel-list"
      aria-hidden="true"
    >
      {podiumCount > 0 && (
        <section className="blb-skel-podium-section">
          <div className="blb-skel-podium-heading shimmer" />

          <div className="blb-skel-podium">
            {podiumPositions
              .slice(0, podiumCount)
              .map((position) => (
                <div
                  key={position}
                  className={
                    `blb-skel-podium-entry ` +
                    `blb-skel-podium-${position}`
                  }
                >
                  <div className="blb-skel-medal shimmer" />

                  <div className="blb-skel-podium-avatar shimmer" />

                  <div className="blb-skel-podium-name shimmer" />

                  <div className="blb-skel-podium-stat shimmer" />
                </div>
              ))}
          </div>
        </section>
      )}

      {Array.from({
        length: remainingCount,
      }).map((_, index) => (
        <div
          className="blb-skel-row"
          key={index}
        >
          <div className="blb-skel-rank-bar shimmer" />

          <div className="blb-skel-rank-wrap">
            <div className="blb-skel-rank shimmer" />
          </div>

          <div className="blb-skel-avatar shimmer" />

          <div className="blb-skel-main">
            <div className="blb-skel-name shimmer" />
            <div className="blb-skel-stat shimmer" />
            <div className="blb-skel-dates shimmer" />
          </div>

          <div className="blb-skel-view shimmer" />
        </div>
      ))}
    </div>
  );
}
